import React from "react";
import facebook from "../images/icons/facebook.svg";
import twitter from "../images/icons/twitter-circled.svg";
import instagram from "../images/icons/instagram.svg";

const DesktopContactInfo = () => {
    return (
        <div className="contact-info" id="desktop-contact">
            <h1>Contact</h1>
            <p className="address">123 Pub on Main, East London</p>
            <p className="phone-number">(043)-123-456.</p>
            <p className="email">info@toast.co.za</p>
            <p className="social-media">
                <img className="facebook" src={facebook} alt="facebook" />
                <img className="twitter" src={twitter} alt="twitter" />
                <img className="instagram" src={instagram} alt="instagram" />
            </p>
            <span className="contact-divider"></span>
            <p className="opening-days">Monday - Thursday</p>
            <p className="opening-times">9-9pm</p>
            <p className="opening-days">Friday - Saturday</p>
            <p className="opening-times">9-11pm</p>
        </div>
    );
};

export default DesktopContactInfo;
